import { type Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import {
	isDefaultRovoChat,
	trimToUndefined,
} from '@atlassian/conversation-assistant-utils/default-agent';

import { normalizeIdentityValue } from './normalizeIdentityValue';
import type { ResponseAuthorIdentity } from './ResponseAuthorIdentity';

export const deriveBaselineAuthorIdentity = (
	agent?: Pick<Agent, 'id'> &
		Partial<Pick<Agent, 'external_config_reference' | 'named_id' | 'is_default'>>,
): ResponseAuthorIdentity => {
	if (agent?.is_default) {
		return { isDefault: true };
	}

	const agentId = trimToUndefined(agent?.id);
	const agentNamedId = trimToUndefined(agent?.external_config_reference ?? agent?.named_id);

	if (agentId) {
		if (isDefaultRovoChat({ agentId })) {
			return { isDefault: true };
		}

		return {
			id: agentId,
			namedId: normalizeIdentityValue(agentNamedId),
			isDefault: false,
		};
	}

	const namedId = normalizeIdentityValue(agentNamedId);

	return {
		namedId,
		isDefault: !namedId,
	};
};
